import {
  type AnnouncementMeta,
  fetchAnnouncementMeta,
} from "@/features/announce/api/announceClient";
import {
  getAnnouncementRetryDelay,
  shouldRetryAnnouncementRequest,
} from "@/features/announce/api/announcementRetryPolicy";

export const ANNOUNCEMENT_META_POLL_INTERVAL_MS = 60_000;

export function createAnnouncementMetaQueryOptions(): {
  queryKey: readonly ["announce", "meta"];
  queryFn: (context: { signal: AbortSignal }) => Promise<AnnouncementMeta>;
  staleTime: number;
  refetchInterval: number;
  refetchIntervalInBackground: false;
  refetchOnWindowFocus: true;
  refetchOnReconnect: true;
  retry: typeof shouldRetryAnnouncementRequest;
  retryDelay: typeof getAnnouncementRetryDelay;
} {
  return {
    queryKey: ["announce", "meta"] as const,
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      fetchAnnouncementMeta({ signal }),
    staleTime: ANNOUNCEMENT_META_POLL_INTERVAL_MS,
    refetchInterval: ANNOUNCEMENT_META_POLL_INTERVAL_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: shouldRetryAnnouncementRequest,
    retryDelay: getAnnouncementRetryDelay,
  };
}
